import _classCallCheck from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { MicrolinkBaseClass } from "../../helpers/microlink";

var Facebook =
/*#__PURE__*/
function (_MicrolinkBaseClass) {
  _inherits(Facebook, _MicrolinkBaseClass);

  function Facebook() {
    var _this;

    _classCallCheck(this, Facebook);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Facebook).apply(this, arguments));
    _this.name = "facebook";
    _this.icon = "<svg aria-hidden=\"true\" viewBox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M128 0c71 0 128 58 128 129 0 64-47 117-108 127v-89h30l6-38h-36v-24c0-10 5-20 21-20h16V53s-15-3-29-3c-29 0-48 18-48 50v29H75v37h1v1h32v89C47 246 1 194 0 131v-2C0 58 57 0 128 0z\" fill=\"#000\" fill-rule=\"nonzero\"/></svg>";
    _this.color = "#1b69f6";
    _this.exampleURL = "https://www.facebook.com/elninotech/photos/a.2066268863489861/2066268886823192/?type=3&theater";

    _this.validator = function (input) {
      return /(https?:\/\/(.+?\.)?(facebook|fb)\.(com|me)(\/[A-Za-z0-9\-\._~:\/\?#\[\]@!$&'\(\)\*\+,;\=]*)?)/.test(input);
    };

    return _this;
  }

  return Facebook;
}(MicrolinkBaseClass);

export { Facebook as default };